import { graphql,
  requestSubscription } from 'react-relay';

// Ajoutez le champ sequence dans la subscription
export const FinishedRemoveWidgetsSubscriptionQuery = graphql`
  subscription FinishedRemoveWidgetsSubscription($filter: BaseSubscriptionInput!) {
    finishedRemoveWidgetsSubscription(filter: $filter) {
      id
      step
      widgets
      sequence
    }
  }
`;

export default (environment) => {
  return requestSubscription(
    environment,
    {
      subscription: FinishedRemoveWidgetsSubscriptionQuery,
      variables: {},
      updater: (
        store,
        { finishedRemoveWidgetsSubscription }
      ) => {
        const { id, step, widgets } = finishedRemoveWidgetsSubscription;
        let record = store.get(id);

        if (!record) {
          record = store.create(id, 'removeWidgets');
        }

        record.setValue(step, 'step');
        record.setValue(widgets, 'widgets');
      },
      onCompleted: () => {},
      onError: error => {
        console.error('SUBSCRIPTION FINISHED REMOVE WIDGETS ERROR:', error.message);
      }
    }
  );
};
